<template>
  <div class="logo-wrap">
     <img class="logo-img" :src = "img" />
     <span class="logo-text">G&C</span>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  data () {
    return {
      img: require('../assets/logo.png')
    }
  }
}
</script>

<style scoped>
  .logo-wrap {
    display: inline-block;
    margin-right: 50px;
    float: left;
  }
  .logo-img {
    vertical-align: bottom;
  }
  .logo-text {
    font-size: 60px;
    font-weight: bolder;
  }
</style>



// WEBPACK FOOTER //
// src/components/logo.vue